import set from 'lodash/set';

const perceptTemplate = id => ({
  perceptType: null,
  key: null,
  concept: null,
  taxedAmount: null,
  exemptAmount: null,
  overtime: [],
  id,
});

const overTimeTemplate = () => ({
  days: null,
  hoursType: null,
  ovetime: null,
  amount: null,
});

const deductionsTemplate = () => ({
  deductionType: null,
  key: null,
  concept: null,
  amount: null,
});

const otherPaymentsTemplate = () => ({
  otherPaymentType: null,
  key: null,
  concept: null,
  amount: null,
});

const paidLeavesTemplate = () => ({
  daysOfPaidLeave: null,
  paidLeaveType: null,
  amount: null,
});

export default {
  setValue(state, { accessor, value }) {
    set(state, accessor, value);
  },
  setValues(state, payload) {
    Object.keys(payload).forEach((key) => {
      set(state, key, payload[key]);
    });
  },
  addPerceptRow(state) { state.percepts.push(perceptTemplate(state.percepts.length)); },
  changePercept(state, { index, name, value }) { set(state.percepts, `[${index}].${name}`, value); },
  deletePercept(state, index) { state.percepts.splice(index, 1); },
  addDeductionRow(state) { state.deductions.push(deductionsTemplate()); },
  changeDeduction(state, { index, name, value }) { set(state.deductions, `[${index}].${name}`, value); },
  deleteDeduction(state, index) { state.deductions.splice(index, 1); },
  addOtherPaymentRow(state) { state.otherPayments.push(otherPaymentsTemplate()); },
  changeOtherPayment(state, { index, name, value }) { set(state.otherPayments, `[${index}].${name}`, value); },
  deleteOtherPayment(state, index) { state.otherPayments.splice(index, 1); },
  addPaidLeaveRow(state) { state.paidLeaves.push(paidLeavesTemplate()); },
  changePaidLeave(state, { index, name, value }) { set(state.paidLeaves, `[${index}].${name}`, value); },
  deletePaidLeave(state, index) { state.paidLeaves.splice(index, 1); },
  addOvertime(state, { index, name, value }) {
    const percept = state.percepts.find(({ id }) => id === index);
    if (!percept) return;
    if ((percept.overtime) === undefined || (percept.overtime).length === 0) {
      percept.overtime.push(overTimeTemplate());
      percept.overtime[0][name] = value;
    } else {
      percept.overtime[0][name] = value;
    }
  },

  setPercepts(state, arrPercepts) {
    arrPercepts.forEach((element) => {
      switch (element.category) {
        case 'percepts':
          state.percepts.splice(0, 1);
          // eslint-disable-next-line
          const percept = id => ({
            perceptType: element.type,
            key: element.key,
            concept: element.concept,
            taxedAmount: element.amount,
            exemptAmount: element.exemptAmount.toString(),
            overtime: [],
            id: state.percepts.length,
          });
          state.percepts.push(percept(state.percepts.length));
          break;
        case 'deductions':
          // eslint-disable-next-line
          const deduction = () => ({
            deductionType: element.type,
            key: element.key,
            concept: element.concept,
            amount: element.amount,
          });
          state.deductions.push(deduction());
          break;
        case 'otherPayments':
          // eslint-disable-next-line
          const otherPayment = () => ({
            otherPaymentType: element.type,
            key: element.key,
            concept: element.concept,
            amount: element.amount,
          });
          state.otherPayments.push(otherPayment());
          break;
        case 'paidLeaves':
          // eslint-disable-next-line
          const paidLeave = () => ({
            paidLeaveType: element.type,
            daysOfPaidLeave: element.disabilityDays,
            amount: element.amount,
          });
          state.paidLeaves.push(paidLeave());
          break;
        default:
          break;
      }
    });
  },
};
